import i18n from "i18next";
import LanguageDetector  from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from './en/en'
import fr from './fr/fr'

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {translation: en},
  fr: {translation: fr},
};

let i18nInstance: typeof i18n

export default class Localization {
  static init() {
    i18n
      .use(initReactI18next) // passes i18n down to react-i18next
      .use(LanguageDetector)
      .init({
        resources,
        // lng: "fr",
        fallbackLng: 'en',
        debug: process.env.NODE_ENV !== 'production',

        keySeparator: '.', // we do not use keys in form messages.welcome

        interpolation: {
          escapeValue: false // react already safes from xss
        },
      });

    i18nInstance = i18n
  }
}

export {i18nInstance};
